import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { isAppleDevice, isTablet } from '../utils/breakpoints';
gsap.registerPlugin(SplitText);
const animateSplitText = (element, type) => {
    const targets = element.querySelectorAll(':scope > h1, :scope > h2, :scope > h3, :scope > p');
    const button = element.querySelectorAll(':scope > .btn, :scope > .link, :scope > .icone');
    if (!targets.length)
        return;
    const timelines = [];
    // 1. Split + créer timeline en pause
    targets.forEach((el) => {
        const split = new SplitText(el, { type: isAppleDevice ? 'words' : type });
        const tl = gsap.timeline({ paused: true });
        tl.from(split.lines, {
            y: 50,
            opacity: 0,
            stagger: 0.08,
            duration: 0.6,
            ease: 'power2.out'
        });
        timelines.push(tl);
    });
    // 2. Intersection → .play() les timelines
    const observer = new IntersectionObserver(([entry], obs) => {
        if (!entry.isIntersecting)
            return;
        element.classList.add('is-visible');
        timelines.forEach(tl => tl.play());
        if (button.length) {
            gsap.to(button, { autoAlpha: 1, y: 0, delay: 0.4 });
        }
        obs.unobserve(entry.target);
    }, {
        threshold: isTablet ? 0.15 : 0.2,
        rootMargin: '-100px 0px'
    });
    observer.observe(element);
};
const registerSplitText = () => {
    const textLineElements = document.querySelectorAll('[data-anim="split"]');
    textLineElements.forEach(el => animateSplitText(el, "lines"));
};
export default registerSplitText;
